import React from 'react'
import { PAYMENT_METHOD_TEXT } from '../../state/const'
import Table from '../../../form/component/Table'
import VipIcon from '../../../form/component/VipIcon'
import { renderStateName } from '../../../process/util/names'
import { renderCountryName } from '../../../customer/util/names'


export default [
    {
        property: 'vip',
        header: 'VIP',
        width: '45',
        renderer: (salesOrder) => {
            return <VipIcon active={!!salesOrder.vip}/>
        },
        columnName: 'salesorder_salesorder.vip',
    },
    {
        property: 'created',
        header: 'Created',
        renderer: Table.dateTimeRenderer('created'),
        columnName: 'salesorder_salesorder.created',
    },
    {
        property: 'referenceNumber',
        header: 'No.',
        columnName: 'salesorder_salesorder.referenceNumber',
    },
    {
        property: 'firstName',
        header: 'Firstname',
        columnName: 'customer_customer.firstName',
    },
    {
        property: 'lastName',
        header: 'Lastname',
        columnName: 'customer_customer.lastName',
    },
    {
        property: 'email',
        header: 'Email',
        columnName: 'customer_customer.email',
    },
    {
        property: 'status',
        header: 'Status',
        renderer: (salesOrder) => {
            return renderStateName(salesOrder.status)
        },
        columnName: 'salesorder_salesorder.status',
    },
    {
        property: 'lastStateTransition',
        header: 'Last Status Change',
        renderer: Table.dateRenderer('lastStateTransition'),
        columnName: 'salesorder_salesorder.lastStateTransition',
    },
    {
        header: 'gender',
        property: 'gender',
        columnName: 'customer_customer.gender',
    },
    {
        property: 'paymentMethod',
        header: 'P. Method',
        renderer: (salesOrder) => {
            return PAYMENT_METHOD_TEXT[salesOrder.paymentMethod]
        },
        columnName: 'salesorder_salesorder.paymentMethod',
    },
    {
        property: 'paymentReceived',
        header: 'P. Received',
        renderer: (value) => {
            return value.paymentReceived === '1' ? 'yes' : 'no'
        },
        columnName: 'salesorder_salesorder.paymentReceived',
    },
    {
        property: 'voucherCode',
        header: 'Voucher',
        columnName: 'salesorder_salesorder.voucherCode',
    },
    {
        property: 'countryCode',
        header: 'Country',
        renderer: (customer) => {
            return renderCountryName(customer.countryCode)
        },
        columnName: 'customer_customer.countryCode',
    },
]





// WEBPACK FOOTER //
// ./src/modules/sales-order/component/search/treatment-column-list.js